/**
 * BL-118 (ruled by Christian 2026-08-06; built after BL-124 so the chip component is shared): one-click presets on the Clients roster,
 * from the page's EXISTING filter vocabulary. The row's examples included "Billing gap" and "Overdue invoices", but it said to "confirm
 * against what the page already filters on before fixing the set". The page filters on owner (`ownerFilter`, by owner NAME) and bookkeeping
 * (`bookkeepingOnly`); billing only drives badges. So the set is All clients · My clients · Bookkeeping clients. Name, taxes, frequency,
 * source and search layer on top. Row selection is untouched (a preset only sets these two atoms).
 */
export interface ClientPreset {
  key: 'allClients' | 'myClients' | 'bookkeepingClients';
  /** true: owned by the signed-in staff member (by name, the space `ownerName` uses); false: any owner. */
  mine: boolean;
  bookkeeping: boolean;
}

export const CLIENT_PRESETS: readonly ClientPreset[] = [
  { key: 'allClients', mine: false, bookkeeping: false },
  { key: 'myClients', mine: true, bookkeeping: false },
  { key: 'bookkeepingClients', mine: false, bookkeeping: true },
];

/** The page opens on All clients (no owner filter, bookkeeping off), as it always has. */
export const DEFAULT_CLIENT_PRESET: ClientPreset['key'] = 'allClients';

export function clientPresetState(preset: ClientPreset, myName: string | null): { ownerFilter: string[]; bookkeepingOnly: boolean } {
  return { ownerFilter: preset.mine && myName ? [myName] : [], bookkeepingOnly: preset.bookkeeping };
}

/** The preset the current owner + bookkeeping state matches exactly, or null ("custom"). */
export function activeClientPreset(ownerFilter: readonly string[], bookkeepingOnly: boolean, myName: string | null): ClientPreset['key'] | null {
  for (const p of CLIENT_PRESETS) {
    if (p.bookkeeping !== bookkeepingOnly) continue;
    if (p.mine ? !!myName && ownerFilter.length === 1 && ownerFilter[0] === myName : ownerFilter.length === 0) return p.key;
  }
  return null;
}
